import { Box } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { annotationSelectors } from '../../../../state/modules/annotation';
import AnnotationInput from './AnnotationInput';

/**
 * Helper component to render the footer of the AnnotationsPanel
 *
 * The footer holds the input for new annotations.
 */
const AnnotationsPanelFooter: FC = () => {
  const hasAnnotationPermission = useSelector(annotationSelectors.hasAnnotationPermission);
  return hasAnnotationPermission ? (
    <Box sx={{ m: 2 }}>
      <AnnotationInput />
    </Box>
  ) : (
    <></>
  );
};

export default AnnotationsPanelFooter;
